const Lights = () => (
  <>
    <ambientLight intensity={ 0.7 } />
    <pointLight position={ [5, 3, 3] } intensity={ 2 } />
  </>
);

export default Lights;
